// src/routes/appSettingsRoutes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Dashboard
import AppSettingsDashboard from "./AppSettingsDashboard";

// Banners
import BannerList from "./Banner/BannerList";
import BannerForm from "./Banner/BannerForm/BannerForm";
import BannerDetails from "./Banner/BannerDetails";

// Offers
// import OfferList from "./Offer/OfferList";
// import OfferForm from "./Offer/OfferForm/OfferForm";
// import OfferDetails from "./Offer/OfferDetails";

// Collections
import CollectionList from "./Collection/CollectionList";
import CollectionForm from "./Collection/CollectionForm/CollectionForm";
import CollectionDetails from "./Collection/CollectionDetails";

// Contact Info
import ContactInfoList from "./Contact/ContactInfoList";
import ContactInfoForm from "./Contact/ContactInfoForm/ContactInfoForm";
import ContactInfoDetails from "./Contact/ContactInfoDetails";

// Feature Flags
import FeatureFlagsManager from "./FeatureFlags/FeatureFlagsManager";

// Config
import ConfigList from "./Config/ConfigList";
import ConfigForm from "./Config/ConfigForm";

const AppSettingsRoutes = () => {
  return (
    <Routes>
      {/* Dashboard */}
      <Route index element={<AppSettingsDashboard />} />
      <Route path="dashboard" element={<AppSettingsDashboard />} />

      {/* Banners */}
      <Route path="banners">
        <Route index element={<BannerList />} />
        <Route path="new" element={<BannerForm mode="add" />} />
        <Route path="edit/:id" element={<BannerForm mode="edit" />} />
        <Route path=":id" element={<BannerDetails />} />
      </Route>

      {/* Offers */}
      {/* <Route path="offers">
        <Route index element={<OfferList />} />
        <Route path="new" element={<OfferForm mode="add" />} />
        <Route path="edit/:id" element={<OfferForm mode="edit" />} />
        <Route path=":id" element={<OfferDetails />} />
      </Route> */}

      {/* Collections */}
      <Route path="collections">
        <Route index element={<CollectionList />} />
        <Route path="new" element={<CollectionForm mode="add" />} />
        <Route path="edit/:id" element={<CollectionForm mode="edit" />} />
        <Route path=":id" element={<CollectionDetails />} />
      </Route>

      {/* Contact Info */}
      <Route path="contact">
        <Route index element={<ContactInfoList />} />
        <Route path="new" element={<ContactInfoForm mode="add" />} />
        <Route path="edit/:id" element={<ContactInfoForm mode="edit" />} />
        <Route path=":id" element={<ContactInfoDetails />} />
      </Route>

      {/* Feature Flags */}
      <Route path="feature-flags" element={<FeatureFlagsManager />} />

      {/* Config */}
      <Route path="config">
        <Route index element={<ConfigList />} />
        <Route path="new" element={<ConfigForm mode="add" />} />
        <Route path="edit/:id" element={<ConfigForm mode="edit" />} />
      </Route>

      {/* Fallback */}
      <Route
        path="*"
        element={<Navigate to="/app-settings/dashboard" replace />}
      />
    </Routes>
  );
};

export default AppSettingsRoutes;
